import { CircularProgress } from "@mui/material";
import type { FC, ReactNode } from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { useChosenDepartment } from "@/contexts/ChosenDepartment/hooks";
import { FEATURE_FLAGS } from "@/contexts/FeatureFlagsProvider";
import { useFeatureFlag } from "@/hooks/useOpenFeatureFlag";

/** The page exists only where overtime insights is on; elsewhere its URL lands on Cost Deep Dive, the page that opens it. */
export const OtOverviewRoute: FC<{ children: ReactNode }> = ({ children }) => {
	const enabled = useFeatureFlag(FEATURE_FLAGS.OtInsightsPage);
	const { search } = useLocation();
	const { departmentId } = useParams();
	const { chosenDepartment } = useChosenDepartment();
	// A URL change can render before its department is adopted; that department's flag must decide access.
	if (chosenDepartment.department_id !== departmentId) return <CircularProgress data-testid="ot-overview-route-loading" />;
	if (!enabled) return <Navigate to={`/${chosenDepartment.department_id}/cost-deep-dive${search}`} replace />;
	return children;
};
